import { Idrug } from '../interface/idrug';
export class Drug implements Idrug {
    constructor(public DrugsId : number, public DrugsName : string,public DrugStrength : string,public DrugInstruction : string,public DrugGenericName : string,public DrugBrand : string,public DrugMRP : number,public DrugMSP : number, public DrugType ){

    }

}



// WEBPACK FOOTER //
// ./src/app/section/master/model/drug.ts